import React, { useEffect, useState } from "react"; 
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";
import AddFamily from "./AddFamily";
import AdminDashboard from "./admindashboard";
import "./hm-theme.css";

function FamilyDetails() {
  const [loading, setLoading] = useState(false);
  const [familyDetails, setFamilyDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const userid = JSON.parse(localStorage.getItem("data"))?.userid;

  const getData = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("data"))?.token;
      const response = await axios.get(`/api/familydetails/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFamilyDetails(response.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  useEffect(() => {
    if (userid) {
      getData();
    }
  }, [userid]);

  const handleAddFamily = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const onClickhandler = async (e, id) => { 
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    setLoading(true);
    try {
      await axios({
        url: "/api/familydetails",
        method: "delete",
        headers: { Authorization: `Bearer ${token}` },
        data: {
          id: `${id}`,
          orgcode: `${JSON.parse(localStorage.getItem("data"))?.orgcode}`,
        },
      });
      toast.success("Family member deleted successfully");
      setLoading(false); 
      getData();
    } catch (error) {
      setLoading(false); 
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleViewAppointments = (memberid) => {
    navigate(`/users/family-profile/${memberid}`);
  };

  return (
    <div>
      <div>
        <AdminDashboard />
      </div>
      {loading && <div className="loading"></div>} 

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4 d-flex align-items-center justify-content-between">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">family_restroom</i>
                Family Details
              </h2>
              <p className="hm-page-subtitle">
                Manage family members, relationship status, and view individual profiles.
              </p>
            </div>
            <button className="btn-hm-primary px-4" onClick={handleAddFamily}>
              <i className="material-icons me-1" style={{ fontSize: "1rem" }}>person_add</i>
              Add Member
            </button>
          </div>

          {/* Results Table Card */}
          <div className="hm-card">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">people</i>
                Family Members List
              </h3>
            </div>
            <div className="hm-card-body p-0">
              {familyDetails.length === 0 ? (
                <div className="hm-empty-state py-5">
                  <i className="material-icons">group_off</i>
                  <p>No Family Members Found</p>
                </div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="hm-table">
                    <thead>
                      <tr>
                        <th>NAME</th>
                        <th>DATE OF BIRTH</th>
                        <th>GENDER</th>
                        <th>PHONE NUMBER</th>
                        <th>RELATIONSHIP STATUS</th>
                        <th className="text-center">ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {familyDetails.map((members, index) => (
                        <tr key={members.id || index}>
                          <td>
                            <span
                              className="fw-semibold text-primary cursor-pointer text-decoration-none"
                              style={{ cursor: "pointer" }}
                              title="View Appointments"
                              onClick={() => handleViewAppointments(members.id)}
                            >
                              {members.name}
                            </span>
                          </td>
                          <td>{members.dob}</td>
                          <td>
                            <span className="hm-badge hm-badge-info">
                              {members.gender}
                            </span>
                          </td>
                          <td>{members.phoneNumber || "N/A"}</td>
                          <td>
                            <span className="hm-badge hm-badge-primary">
                              {members.relationship}
                            </span>
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-sm btn-outline-danger border-0 rounded-circle p-1"
                              title="Delete Family Member"
                              onClick={(e) => onClickhandler(e, members.id)}
                            >
                              <MdDeleteForever size={20} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          {isModalOpen && (
            <AddFamily isOpen={isModalOpen} onRequestClose={handleCloseModal} userid={userid} />
          )}
        </div>
      </div>
    </div>
  );
}

export default FamilyDetails;